<div class="app-layout" [class.sidebar-collapsed]="sidebarCollapsed()">
  <!-- Backdrop for tablet/mobile view -->
  <div class="sidebar-backdrop" 
       [class.show]="sidebarOpen()" 
       (click)="closeSidebar()"
       *ngIf="sidebarOpen()"></div>

  <!-- Sidebar -->
  <app-sidebar [isOpen]="sidebarOpen()" [isCollapsed]="sidebarCollapsed()" (linkClicked)="onSidebarLinkClicked()"></app-sidebar>

  <!-- Header and Content Area -->
  <div class="layout-wrapper">
    <!-- Header -->
    <app-header (toggleSidebar)="toggleSidebar()"></app-header>

    <!-- Main Content Area -->
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
